import { Box, Container, CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { I18nextProvider } from 'react-i18next';

import { theme } from '~/assets/muiTheme/muiTheme';
import { AuthModal } from '~/base/ui/AuthModal';
import { i18n } from '~/modules/lang/LangAdapter';
import { LangTypeEnum } from '~/modules/lang/types/Lang';
import { FileModeEnum } from '~modules/fileTypes/types/FileModeEnum';

import MFAttachedDocuments from '../apps/MFAttachedDocuments';
import { MFComponentEnum } from '../types/MFTypes';

export const ReactWrapper = () => {
  const [mfComponent] = useState<MFComponentEnum>(MFComponentEnum.EXAMPLE_COMPONENT);

  // Имитация обертки родительского проекта
  return (
    <I18nextProvider i18n={i18n}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          {mfComponent === MFComponentEnum.EXAMPLE_COMPONENT && (
            <Container maxWidth="xl">
              <Box py={{ xs: 2, sm: 3 }}>
                {/*
              В этом месте рендерим нужный модуль MF для локального запуска и разработки
              с необходимыми данными имитирую рендер на родительском проекте
            */}
                <MFAttachedDocuments
                  // isWebView
                  // onEdit={(scheduleId: string, isEditingNew?: boolean) => {
                  //   postMessage({ type: 'EDIT', scheduleId, isEditingNew });
                  // }}
                  // Base
                  // apiUrl={props.apiUrl}
                  //Зашлушка, чтоб не было варнингов
                  accessToken={''}
                  refreshToken={''}
                  mode={FileModeEnum.ALL}
                  // onLogout={() => {
                  //   postMessage({ type: 'LOGOUT' });
                  // }}
                  lang={LangTypeEnum.RU}
                  // toast={toast}
                  documentId={1}
                  documentTypeId={1}
                />

                {/* Для разработки в dev mode */}
                <Toaster position="top-right" reverseOrder={false} />

                {/* Для разработки в dev mode */}
                <AuthModal />
              </Box>
            </Container>
          )}
        </ThemeProvider>
      </StyledEngineProvider>
    </I18nextProvider>
  );
};
